import React, { useState, useEffect } from "react";
import SideNavigation from "../../components/dumb/projectManager/SideNavigation";
import useAuthEffect from "../../hook/useAuthEffect";
import { useSelector } from "react-redux";
import { fetchGlossaries } from "../../redux/ducks/glossary";
import useStatusThunk from "../../hook/useStatusThunk";
import { mapData } from "../../helpers/mapRow";
import { Table } from "../../components/dumb/DataTable";
import CreateGlossary from "../../components/smart/buttonPopups/CreateGlossary";
import DeleteGlossary from "../../components/smart/buttonPopups/DeleteGlossary";

const GlossariesRoute = () => {

    const glossaries = useSelector(state => state.glossary.glossaries);
    const [rows, setRows] = useState([]);
    const [dispatchFetchGlossaries, status] = useStatusThunk(fetchGlossaries);

    //Fetch glossaries
    useAuthEffect(isAuth => dispatchFetchGlossaries());

    useEffect(() => {
        if (status == "success") setRows(mapData(glossaries));
    }, [status, glossaries]);

    return (
        <div className="columns-container">
            <div className="column column--sidenav">
                <SideNavigation selected="glossaries" />
            </div>

            <div className="column column--primary">
                <Glossaries rows={rows} />
            </div>
        </div >
    )
}

const Glossaries = props => {

    const glossaryURL = "/PM/glossary/view/:glossaryID";
    const [checkValues, setCheckValues] = useState([]);

    const renderRow = (row, renderData) =>
        <React.Fragment>
            {renderData(row.ID, { key: "id" })}
            {renderData(row.name, { key: "name", here: glossaryURL.replace(":glossaryID", row.ID) })}
            {renderData(row.desc, { key: "desc" })}
            {renderData(row.sourceLang, { key: "sourcelang" })}
        </React.Fragment>

    let titleContent = <React.Fragment>
        <DeleteGlossary glossaryID={checkValues[0]} className={checkValues.length == 1 ? "" : "button--disabled"} />
        <CreateGlossary />
    </React.Fragment>

    return (
        <Table checkbox={true} newCheckValues={setCheckValues} getCheckValue={row => row.ID} title={"Glossaries"} titleContent={titleContent} renderRow={renderRow}
            rows={props.rows} cols={[{ name: "id", sortCol: "ID" }, { name: "name", sortCol: "name" }, { name: "desc", sortCol: "desc" }, { name: "source", sortCol: "sourceLang" }]} />
    )
}


export default GlossariesRoute;